
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class GradientExternalLinkIcon extends Vue {
  @Prop({ default: 27 }) private size!: number | string;
  @Prop({ default: '' }) private fillColor!: string;
  @Prop({ default: 'clip0' }) private clipPathId!: string;
  @Prop({ default: 'paint0_linear' }) private gradientId!: string;
}
